import React from 'react'
import { Select } from '@mantine/core'

import { ReporterBase } from '@/types'
import { getReporterLabel } from '@/utils/parrot'

export const ReporterSelect: React.FC<
  {
    reporters: ReporterBase[]
    value?: ReporterBase
    onChange: (value?: ReporterBase) => void
    showLevel?: boolean
    showState?: boolean
  } & Omit<React.ComponentProps<typeof Select>, 'value' | 'data' | 'onChange'>
> = ({
  reporters,
  value,
  onChange,
  showLevel = true,
  showState = false,
  ...props
}) => {
  return (
    <Select
      {...props}
      data={reporters.map(reporter => ({
        value: reporter.id,
        label: getReporterLabel(reporter, { showLevel, showState }),
      }))}
      disabled={reporters.length === 0}
      value={value?.id ?? null}
      onChange={value =>
        onChange(reporters.find(r => r.id === value) ?? undefined)
      }
      searchable
    />
  )
}
